import { Card } from "react-bootstrap";
import Tag from "../../../SharedComponents/Tag";

/**
 * Consistent card frame for every SuperAdmin list row.
 *
 * Layout: an inner flex container that keeps the main info on the left and the
 * action cluster on the right, wrapping gracefully on narrow widths. Use the
 * exported <AdminListMain> and <AdminActions> for the two sides.
 */
export default function AdminListCard({ tag, footer, className = "", children }) {
  return (
    <Card className={`admin-list-card mb-3 ${className}`.trim()}>
      {tag && <Tag tag={tag} />}
      <Card.Body>
        <div className="admin-list-card__inner">{children}</div>
        {footer && <div className="admin-list-card__footer">{footer}</div>}
      </Card.Body>
    </Card>
  );
}

export function AdminListMain({ className = "", children }) {
  return <div className={`admin-list-card__main ${className}`.trim()}>{children}</div>;
}
